<template>
  <div id="frame">
    <div class="alert alert-warning" v-if="!$online">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Bitte stellen Sie eine Internetverbindung her!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <card :title="title" :subTitle="subtitle" v-if="tick === 1" id="frame">
      <v-text-field
        v-model="date"
        label="Lieferscheindatum"
        type="date"
        readonly
      ></v-text-field>
      <v-text-field
        v-model="name"
        :error-messages="nameErrors"
        label="Ihr Name"
        @input="$v.name.$touch()"
        @blur="$v.name.$touch()"
        required
        clearable
        @click:clear="clear('name')"
      ></v-text-field>
      <v-select
        v-model="selectedLieferant"
        :items="lieferanten"
        item-text="name"
        item-value="name"
        label="Lieferant"
        return-object
        attach
        required
      ></v-select>
      <v-select
        v-model="selectedHerkunft"
        :items="herkunft"
        item-text="name"
        item-value="name"
        label="Herkunft"
        return-object
        attach
        required
      ></v-select>
      <!-- <v-divider/> -->
      <p style="margin-bottom: unset">
        <label>Kennzeichnungsangaben:</label>
        <span style="margin-left: 1.05vw"></span>
        <label class="custom-file-upload btn btn-sm btn-success" v-if="this.image ===''">
          <input type="file" accept="image/*" capture="" @change="onFileChangeImage($event)">
          Foto aufnehmen
        </label>
        <button class="btn btn-sm btn-danger" v-if="this.image !== ''" @click="removeImage($event)">Foto entfernen</button>
      </p>
      <!-- <div v-if="!this.hasPicture">
        <p>Etikett mit allen Angaben vorhanden (Foto aufnehmen)?</p>
        <button class="btn btn-danger" v-on:click="changeHasPicture(false)" type="button">Nein</button>
        <span class="buttonMargin"></span>
        <button class="btn btn-success" v-on:click="changeHasPicture(true)" type="button">Ja</button>
      </div> -->
      <div v-if="this.image !== ''">
        <v-text-field
          v-model="product"
          :error-messages="productErrors"
          label="Produkt / Artikel"
          @input="$v.product.$touch()"
          @blur="$v.product.$touch()"
          required
          clearable
          @click:clear="clear('product')"
        ></v-text-field>
        <div>
          <img :src="image"/>
        </div>
      </div>
      <div v-if="this.image === ''">
        <v-text-field
          v-model="product"
          :error-messages="productErrors"
          label="Produkt / Artikel"
          @input="$v.product.$touch()"
          @blur="$v.product.$touch()"
          required
          clearable
          @click:clear="clear('product')"
        ></v-text-field>
        <v-text-field
          v-model="identNummer"
          :error-messages="identNummerErrors"
          label="Ident.-Nr."
          @input="$v.identNummer.$touch()"
          @blur="$v.identNummer.$touch()"
          type="text"
          required
          clearable
          @click:clear="clear('identNummer')"
        ></v-text-field>
        <v-text-field
          v-model="slaughter"
          :error-messages="slaughterErrors"
          label="Schlachtbetrieb"
          @input="$v.slaughter.$touch()"
          @blur="$v.slaughter.$touch()"
          required
          clearable
          @click:clear="clear('slaughter')"
        ></v-text-field>
        <div v-if="!this.betrieb">
          <p>Schlachtbetrieb = Zerlegungsbetrieb?</p>
          <button class="btn btn-danger" v-on:click="equalBetrieb(false)" type="button">Nein</button>
          <span class="buttonMargin"></span>
          <button class="btn btn-success" v-on:click="equalBetrieb(true)" type="button">Ja</button>
        </div>
        <v-text-field
          v-model="cutting"
          :error-messages="cuttingErrors"
          label="Zerlegungsbetrieb"
          @input="$v.cutting.$touch()"
          @blur="$v.cutting.$touch()"
          required
          clearable
          @click:clear="clear('cutting')"
          v-if="this.betrieb"
        ></v-text-field>
      </div>
      <div v-if="this.hasPicture">
        <button class="btn btn-danger" v-on:click="cancelKennzeichnung()" type="button">zurück</button>
      </div>
      <!-- <v-divider/> -->
      <!-- <v-select
        v-model="selectedSBWare"
        :items="sbWare"
        item-text="name"
        item-value="name"
        label="SB-Ware / Verwendung"
        return-object
        attach
        required
      ></v-select> -->
      <v-select
        v-model="selectedSBWare"
        :items="sbWare"
        item-text="name"
        item-value="name"
        label="SB-Ware / Verwendung"
        return-object
        chips
        multiple
        attach
        required
      ></v-select>
      <v-text-field
        v-model="dateTheke"
        label="In die Theke gelegt (optional)"
        type="date"
      ></v-text-field>
      <v-divider/>
      <!-- <v-btn @click="submit">submit</v-btn> -->
      <button class="btn btn-lg btn-danger float-left" v-on:click="goBack()" type="button">abbrechen</button>
      <button class="btn btn-lg btn-success float-right" v-on:click="nextTick()" type="button">bestätigen</button>
    </card>

    <card :title="title2" v-if="tick === 2" id="frame">
      <hr>
      <!-- bestätigen --> 
      <div class="angaben">
        <p class="messstelle">{{title}}</p>
         <table style="width:100%; font-size: 16px">
          <colgroup>
            <col span="1" style="width: 200px;">
            <col span="1">
          </colgroup>
          <tr>
            <td>Lieferscheindatum:</td>
            <td>{{ date | formatDate }}</td>
          </tr>
          <tr>
            <td>Ihr Name:</td>
            <td>{{ name }}</td>
          </tr>
          <tr>
            <td>Lieferant:</td>
            <td>{{ selectedLieferant.name }}</td>
          </tr>
          <tr>
            <td>Herkunft:</td>
            <td>{{ selectedHerkunft.name }}</td>
          </tr>
        </table>
        <br>
        <p>Kennzeichnungsangaben:</p>
        <v-container v-if="this.image === ''" style="padding: 0; margin: 0;">
          <table style="width:100%; font-size: 16px">
            <colgroup>
              <col span="1" style="width: 200px;">
              <col span="1">
            </colgroup>
            <tr>
              <td>Produkt / Artikel:</td>
              <td>{{ product }}</td>
            </tr>
            <tr>
              <td>Ident.-Nr.:</td>
              <td>{{ identNummer }}</td>
            </tr>
            <tr>
              <td>Schlachtbetrieb:</td>
              <td>{{ slaughter }}</td>
            </tr>
            <tr>
              <td>Zerlegungsbetrieb:</td>
              <td>{{ cutting }}</td>
            </tr>
            <tr>
              <td>SB-Ware / Verwendung:</td>
              <!-- <td>{{ selectedSBWare.name }}</td> -->
              <td>
                <span v-for="(kategorie, index) of selectedSBWare" :key="kategorie.value">
                  {{ kategorie.name }}<span v-if="selectedSBWare.length > 0 && index !== (selectedSBWare.length - 1)">,</span>
                  </span>
              </td>
            </tr>
            <tr>
              <td>In die Theke gelegt:</td>
              <td>{{ dateTheke | formatDate }}</td>
            </tr>
          </table> 
        </v-container>
        <v-container v-if="this.image !== ''" style="padding: 0; margin: 0;">
          <table style="width:100%; font-size: 16px">
            <colgroup>
              <col span="1" style="width: 200px;">
              <col span="1">
            </colgroup>
            <tr>
              <td>Produkt / Artikel:</td>
              <td>{{ product }}</td>
            </tr>
          </table>
          <br>
          <div>
            <img :src="image"/>
          </div>
        </v-container>
      </div>
      <hr>
      <div v-if="!this.question">
        <p class="messstelle">Weitere OrgaInvent hinzufügen?</p>
        <button class="btn btn-danger" v-on:click="changeQuestion()" type="button">Nein</button>
        <span class="buttonMargin"></span>
        <button class="btn btn-success" v-on:click="save('newArticle')" type="button">Ja</button>
      </div>
      <div v-if="this.question">
        <button class="btn btn-lg btn-danger float-left" v-on:click="cancel(); changeQuestion()" type="button">abbrechen</button>
        <button class="btn btn-lg btn-success float-right" v-on:click="save()" type="button">bestätigen</button>
      </div>
    </card>

    <div class="alert alert-warning" v-if="showLoadingMessage && tick === 3" id="alert">
      <!-- Loading -->
      <button type="button" aria-hidden="true" class="close"></button>
      <center>
        <span>Eintrag wird erstellt, bitte warten</span>
        <br>
        <v-progress-circular :size="30" :width="7" color="red" indeterminate></v-progress-circular>
      </center>
    </div>
    <div class="alert alert-success" v-if="showSuccessMessage && tick === 3" id="alert">
      <!-- Erfoglsmeldung -->
      <button type="button" aria-hidden="true" class="close"></button>
      <span>
      <b>Erfolgreich erstellt! - </b> Ein entsprechender Eintrag wurde vorgenommen!</span>
    </div>
     <div class="alert alert-danger" v-if="showOnlineMessage && tick === 3 && $online">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Upload dauert länger. ({{ counterFront }} Sekunden)</b>
      </span>
      <!-- <button v-if="counterFront === 10" class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button> -->
    </div>
    <div class="alert alert-danger" v-if="showOnlineMessage && tick === 3 && !$online">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Stellen Sie eine Internetverbindung her. ({{ counterFront }} Sekunden)</b>
      </span>
      <!-- <button v-if="counterFront === 10" class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button> -->
    </div>
    <div class="alert alert-danger" v-if="showErrorMessage && tick === 4">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
      <span>
        <b>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut</b>
      </span>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required} from 'vuelidate/lib/validators';
import Compressor from 'compressorjs';


export default {
  mixins: [validationMixin],
  validations: {
    name: { required },
    slaughter: { required },
    cutting: { required },
    product: { required },
    identNummer: { required },
  },

  data () {
    return {
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      title: "OrgaInvent",
      title2: "Angaben bestätigen",
      subtitle: "Neue OrgaInvent anlegen",
      loading: false,
      time:"",
      uploadAnzahl: "",
      uploadZaehler: "",
      counterFront: 0,
      // models:
      date: "",
      name: "",
      selectedLieferant: {},
      selectedHerkunft: {},
      selectedSBWare: [],
      // Kennzeichnungsangaben:
      image: "",
      product: "",
      identNummer: "",
      slaughter: "",
      cutting: "",
      dateTheke: "",
      // bools:
      betrieb: false,
      imageState: false,
      showImageBool: false,
      hasPicture: false,
      tick: 1,
      showErrorMessage: false,
      showSuccessMessage: false,
      showOnlineMessage: false,
      showLoadingMessage: false,
      question: false,
      showAlarm: false,
      showSuccess: false,

      lieferanten:[
        { value: 1, name: "REWE" },
        { value: 2, name: "Nagel" },
        { value: 3, name: "Vita Beef" },
        { value: 4, name: "Niegemann" },
      ],
      herkunft:[
        { value: 1, name: "1: Herkunft, Zerlegung Herstellung: Deutschland" },
        { value: 2, name: "2: Argenada = Herkunft, Zerlegung: Argentinien" },
        { value: 3, name: "3: Färsenfleisch bayrischer Wald = Herkunft, Zerlegung: bayrischer Wald (Deutschland)" },
        { value: 4, name: "4: Irish Beef = Herkunft, Zerlegung: Irland" },
        { value: 5, name: "5: Wagyu Beef = Herkunft, Zerlegung: Neuseeland" },
        { value: 6, name: "6: Charolals Rind = Herkunft, Zerlegung: Frankreich" },
        { value: 7, name: "7: US Beef Variante I = Herkunft, Zerlegung: USA" },
        { value: 8, name: "8: US Beef Variante II = Herkunft, Zerlegung: USA und Deutschland" },
        { value: 9, name: "9: Bison Variante I = Herkunft, Zerlegung: Kanada" },
        { value: 10, name: "10: Bison Variante II = Geburt und Mast: Kanada; Schlachtung und Zerlegung: USA" },
      ],
      sbWare: [
        { value: 1, name: "Braten/Gulasch" },
        { value: 2, name: "Rouladen" },
        { value: 3, name: "Suppenfleisch" },
        { value: 4, name: "Steak" },
        { value: 5, name: "Hackfleisch" },
      ],

      dst:[
        {year: 2019, start: "2019-03-31", ende: "2019-10-27"},
        {year: 2020, start: "2020-03-29", ende: "2020-10-25"},
        {year: 2021, start: "2021-03-28", ende: "2021-10-31"},
        {year: 2022, start: "2022-03-27", ende: "2022-10-30"},
        {year: 2023, start: "2023-03-26", ende: "2023-10-29"},
        {year: 2024, start: "2024-03-31", ende: "2024-10-27"},
        {year: 2025, start: "2025-03-30", ende: "2025-10-26"},
        {year: 2026, start: "2026-03-29", ende: "2026-10-25"},
        {year: 2027, start: "2027-03-28", ende: "2027-10-31"},
        {year: 2028, start: "2028-03-26", ende: "2028-10-29"},
        {year: 2029, start: "2029-03-25", ende: "2029-10-28"}
      ],
    }
  },
  methods: {
    disableNotification(){
      this.showAlarm = false;
      this.showSuccess = false;
    },
    changeQuestion() {
      this.question = !this.question;
    },
    goBack(index) {
      index === 1 ? this.$router.push({path: "/qs/servicelisten/orgainvent"}) : this.$router.go(-1);
    },
    clear(index) {
      switch(index) {
        case 'name':
          this.name = "";
        break;
        case 'product':
          this.product = "";
        break;
        case 'identNummer':
          this.identNummer = "";
        break;
        case 'slaughter':
          this.slaughter = "";
        break;
        case 'cutting':
          this.cutting = "";
        break;
      }
    },
    cancel(bool) {
      if (bool) {
        this.showSuccessMessage = false;
        this.selectedLieferant = {};
        this.selectedHerkunft = {};
        this.selectedSBWare = [];
        this.image = "";
        this.slaughter = "";
        this.cutting = "";
        this.tick = 1;
      } else {
        this.tick = 1;
      }
    },
    equalBetrieb(bool) {
      this.betrieb = !this.betrieb;
      bool ? this.cutting = this.slaughter : '';
    },
    cancelKennzeichnung() {
      this.hasPicture = !this.hasPicture;
    },
    removeImage(e) {
      this.image = '';
    },
    onFileChangeImage(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }
      Promise.resolve(this.compressImage(files[0])).then((value) => {
        this.createImage(value);
      });
    },
    compressImage(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.6,
          success: (result) => {
            resolve(new File([result], file.name, {type: result.type}));
          }, error: (error) => reject(error)
        });
      })
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
      this.imageState = true;
    },
    removeImage(e) {
      this.image = '';
      this.imageState = false;
    },
    nextTick() {
      this.$v.$touch();
      if (this.image !== '' &&
          !this.$v.name.$invalid &&
          this.selectedLieferant.value !== undefined &&
          this.selectedHerkunft.value !== undefined &&
          this.selectedSBWare.length !== 0 &&
          this.product !== '') {
        this.tick += 1;
      } else if (!this.$v.$invalid && this.image === '') {
        this.tick += 1;
      }
    },
    createToday() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var date = yyyy+ '-' + mm + '-' + dd;
      this.date = date;

      //DST check
      var thisYear= yyyy;
      var dstEnd;
      var dstStart;
      for (var i =0; i < this.dst.length; i++){
        if(this.dst[i].year == thisYear){
          dstEnd =  new Date(this.dst[i].ende);
          dstStart = new Date(this.dst[i].start);
        }
      }
      
      if(new Date(date) < dstEnd && new Date(date) >= dstStart ){
        const tmpHour = (today.getUTCHours()+2) < 10 ? '0' + (today.getUTCHours()+2) : (today.getUTCHours()+2);
        if(+today.getUTCMinutes()<10) {
          this.time = tmpHour+ ':0' + today.getUTCMinutes();
        } else{
          this.time = tmpHour+ ':' + today.getUTCMinutes();
        }
      }else{
        const tmpHour = (today.getUTCHours()+1) < 10 ? '0' + (today.getUTCHours()+1) : (today.getUTCHours()+1);
        if(+today.getUTCMinutes()<10){
          this.time = tmpHour + ':0' + today.getUTCMinutes();
        } else{
          this.time = tmpHour + ':' + today.getUTCMinutes();
        }
      }
    },
    save(newArticle) {
      if (this.image !== '') {
        this.identNummer = "";
        this.slaughter = "";
        this.cutting = "";
      }

      var tmpSBWare = [];
      this.selectedSBWare.map(kategorie => tmpSBWare.push(kategorie.value));
      var tmpDate = '';
      this.dateTheke === '' ? tmpDate = JSON.stringify([]) : tmpDate = JSON.stringify([this.dateTheke]);
      let orgaInventlist = {
        lieferscheindatum: this.date,
        name: this.name,
        lieferant: this.selectedLieferant.value,
        herkunft: this.selectedHerkunft.value,
        product: this.product,
        identNummer: this.identNummer,
        slaughter: this.slaughter,
        cutting: this.cutting,
        sbware: JSON.stringify(tmpSBWare),
        theke: tmpDate,
        image: this.image,
        sold: 0
      }
      
      if (newArticle === 'newArticle') {
        this.nextTick();
        this.showLoadingMessage = true;
        let counter = 0;
        let internetCounter = 0;
        var interval = setInterval(() => {
          if (this.$online && internetCounter === 0) {
            internetCounter = 1;
            this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/orgainvent/liste/add', orgaInventlist, { headers: {'Authorization': this.auth }})
              .then(function(response) {
                if(response.body.error) {
                  console.log(response.body.error);
                  this.nextTick();
                  this.showLoadingMessage = false;
                  this.showErrorMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.cancel(true), 1500);
                } else {
                  this.showLoadingMessage = false;
                  this.showOnlineMessage = false;
                  this.showSuccessMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.cancel(true), 1500);
                }
            });
          } else {
            this.counterFront++;
            if (counter === 3) {
              this.showOnlineMessage = true;
            }
          }
          counter++;
          if (counter === 10) {
            clearInterval(interval);
          }
        }, 1000);
      } else {
        this.nextTick();
        this.showLoadingMessage = true;
        let counter = 0;
        let internetCounter = 0;
        var interval = setInterval(() => {
          if (this.$online && internetCounter === 0) {
            internetCounter = 1;
            this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/qs/orgainvent/liste/add', orgaInventlist, { headers: {'Authorization': this.auth }})
              .then(function(response) {
                if(response.body.error) {
                  console.log(response.body.error);
                  this.nextTick();
                  this.showLoadingMessage = false;
                  this.showErrorMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.$router.push({path: "/qs/servicelisten/orgainvent" }), 1500);
                } else {
                  this.showLoadingMessage = false;
                  this.showOnlineMessage = false;
                  this.showSuccessMessage = true;
                  this.counterFront = 0;
                  clearInterval(interval);
                  setTimeout(() => this.$router.push({path: "/qs/servicelisten/orgainvent" }), 1500);
                }
            });
          } else {
            this.counterFront++;
            if (counter === 0) {
              this.showOnlineMessage = true;
            }
          }
          counter++;
          if (counter === 10) {
            clearInterval(interval);
          }
        }, 1000);
      }
    },
  },
  created: function() {
    this.createToday();
  },
  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.required && errors.push('Bitte geben Sie Ihren Namen ein');
      return errors;
    },
    slaughterErrors () {
      const errors = []
      if (!this.$v.slaughter.$dirty) return errors
      !this.$v.slaughter.required && errors.push('Bitte geben Sie einen Schlachtbetrieb ein');
      return errors;
    },
    productErrors () {
      const errors = []
      if (!this.$v.product.$dirty) return errors
      !this.$v.product.required && errors.push('Bitte geben Sie einen Artikel ein');
      return errors;
    },
    cuttingErrors () {
      const errors = []
      if (!this.$v.cutting.$dirty) return errors
      !this.$v.cutting.required && errors.push('Bitte geben Sie einen Zerlegungsbetrieb ein');
      return errors;
    },
    identNummerErrors () {
      const errors = []
      if (!this.$v.identNummer.$dirty) return errors
      !this.$v.identNummer.required && errors.push('Bitte geben Sie die Ident.-Nr. ein');
      return errors;
    },
  },
}
</script>

<style scoped>
  #frame{
      margin-left: 0%;
      margin-top: 0%;
      padding-left: 0%;
      padding-top: 0%;
      padding-right: 0%;

  }
  .v-messages__message{
    color: rgb(255, 115, 0);
  }
  .instruction{
      text-align: center;
      font-weight: bold;
  }
  .pad{
    border: 2px solid rgb(117, 108, 108);
    border-radius: 5px ;
  }
  .messstelle{
      font-weight: bold;
      font-size: large;
  }
  .angaben{
  font-size: large;
  }

  .pointer {
    cursor: pointer;
  }
  .picture {
    padding-left: 70px;
  }

  .pictureText {
    font-size: 13px;
  }

  .boldtxt{
    font-weight: bold;
  }

  input[type="file"] {
      display: none;
  }
  .custom-file-upload {
      display: inline-block;
      padding: 4px 10px;
      cursor: pointer;
      color: #ffffff;
      border-radius: 0.25rem;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 600;
      line-height: 1.75;
  }

  .is--disabled {
    opacity: 0.65;
  }
  .is--disabled:hover {
    background-color: #cc071e;
  }

  .buttonMargin {
    margin-left: 5px;
  }

  img {
    width: 45%;
    margin: auto;
    display: block;
    margin-bottom: 10px;
  }

  .container {
    padding-top: 12px;
    padding-bottom: 0px;
    margin-top: 4px;
    margin-left: 0px;
    margin-right: 0px;
  }

</style>